// extracted by css-extract-rspack-plugin
module.exports =  {"gray-item":"Item-YZBI__gray-item","index":"Item-SL0V__index"};